<mat-toolbar>
  <mat-icon *ngIf="canNavigateUp" class="pointer" (click)="navigateUp()">arrow_back</mat-icon>
  <span style="margin-left: 8px; font-size: 85%;">{{path || selectedLocation}}</span>
  <span class="spacer"></span>
  <span class="element-level">Level - {{level}}</span>
  <span class="spacer"></span>
  <div class="filtercontainer">
    <span *ngIf="selection.selected.length>0">
      <button style="margin-bottom: 2px;" mat-raised-button (click)="exportDocuments()">
        <mat-icon>cloud_download</mat-icon> Export
      </button>
    </span>
    <mat-form-field class="element-filter">
      <mat-label style="font-size: medium;">Filter</mat-label>
      <input matInput (keyup)="applyFilterOnFolders($event)">
    </mat-form-field>
  </div>
</mat-toolbar>


<div style="height: 500px;" *ngIf="pagedList">

  <div fxFlex fxLayout="row" fxLayoutAlign="space-between start">
    <div class="content" fxFlex fxLayout="row">
      <mat-grid-list cols="10" rowHeight="100px" (window:resize)="onResize($event)" fxFlex >
        <mat-grid-tile *ngFor="let element of pagedList" class=file-or-folder>
          <div fxLayout="column" fxLayoutAlign="space-between center" (click)="navigate(element)">

            <mat-icon class="file-or-folder-icon pointer" *ngIf="element.isFolder">folder</mat-icon>
            <div *ngIf="!element.isFolder">
              <span style="float: left; size: 10%;">
                <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element.documentId) : null;isSomeSelected()"
                  [checked]="selection.isSelected(element.documentId)">
                </mat-checkbox>
              </span>
              <span>
                <mat-icon svgIcon="pdf" *ngIf="element.filetype.endsWith('pdf')" class="file-icon pointer"></mat-icon>
                <mat-icon svgIcon="jpeg" *ngIf="element.filetype.endsWith('jpeg') || element.filetype.endsWith('png')"
                  class="file-icon pointer"></mat-icon>
                <mat-icon svgIcon="ppt" *ngIf="element.filetype.endsWith('presentation')" class="file-icon pointer">
                </mat-icon>
                <mat-icon svgIcon="xls" *ngIf="element.filetype.endsWith('sheet') || element.filetype.endsWith('excel')"
                  class="file-icon pointer"></mat-icon>
                <mat-icon svgIcon="txt" *ngIf="element.filetype.endsWith('plain')" class="file-icon pointer"></mat-icon>
                <mat-icon svgIcon="doc" *ngIf="element.filetype.endsWith('document')" class="file-icon pointer">
                </mat-icon>
              </span>
            </div>

            <!-- <mat-icon color="primary" class="file-or-folder-icon pointer" *ngIf="!element.isFolder">insert_drive_file</mat-icon> -->
            <span class="folderclass">{{element.name}}</span>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </div>
</div>
<mat-paginator [pageSizeOptions]="[50, 100, 200]" [length]="length" [pageSize]="50" (page)="OnPageChange($event)"
  showFirstLastButtons></mat-paginator>